(() => {
  const initSearch = (root) => {
    if (root.dataset.scReady === 'true') return;
    root.dataset.scReady = 'true';
    root.querySelector('[data-sc-search-sort]')?.addEventListener('change', (event) => event.target.form.submit());
  };
  const initAll = (scope = document) => scope.querySelectorAll('[data-sc-search]').forEach(initSearch);
  document.addEventListener('DOMContentLoaded', () => initAll());
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
